import { Box, Skeleton, Stack } from '@mui/material';
import { startCase } from 'lodash';

import { Text } from 'common';

import { type ReactFlowBlockTypeData } from '../../../types';
import { useBlockTypeMetadata } from '../../Configs/useBlockTypeMetadata';

interface NodeHeaderLabelProps {
  data: ReactFlowBlockTypeData;
  isSelected: boolean;
}

export function NodeHeaderLabel(props: NodeHeaderLabelProps) {
  const {
    data: { uiBlockType, label },
  } = props;
  const nodeLabel = startCase(label);
  const blockContentResults = useBlockTypeMetadata({ uiBlockType });
  return (
    <Stack direction="row" gap={0.5} justifyContent="space-between" alignItems="center">
      <Box>
        <Text variant="subtitle2" color="inherit">
          {blockContentResults.isPending ? (
            <Skeleton />
          ) : blockContentResults.data?.name.toLowerCase() !== nodeLabel.toLowerCase() ? (
            blockContentResults.data?.name
          ) : (
            ''
          )}
        </Text>
        <Text
          variant="subtitle2"
          color="inherit"
          bold
          sx={{
            overflowX: 'hidden',
            overflowY: 'auto',
            textWrap: 'auto',
            lineBreak: 'anywhere',
            maxHeight: '3em',
          }}
        >
          {nodeLabel}
        </Text>
      </Box>
    </Stack>
  );
}
